import { AUTH_ROUTE_PREFIX, appPaths } from "@/constants/paths";
import { GlobalModalProvider } from "@/context/GlobalModalProvider";
import { PreviousPathProvider } from "@/context/PreviousPathProvider";
import { useAuth } from "@/hooks/use-auth";
import { useIdleLogout } from "@/hooks/use-idle-logout";
import { getAccessToken } from "@/utils/auth-storage";
import { setLoginRedirect } from "@/utils/session-teardown";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const RootLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // const showSnackbar = useSnackbar();
  const { logout } = useAuth();
  /**
   * user stays for the [30mn] idle session will terminate & log out —
   * armed only once a session exists, never on the login/password screens.
   */
  const isIdleLogoutEnabled =
    !pathname.startsWith(AUTH_ROUTE_PREFIX) && !!getAccessToken();
  useIdleLogout({
    onIdle: () => logout(true),
    enabled: isIdleLogoutEnabled,
  });

  /**
   * The axios interceptor runs outside React, so it cannot navigate on its own.
   * Handing it the router's navigate keeps an expired session from reloading
   * the document to reach the login page.
   */
  useEffect(() => {
    setLoginRedirect(() => navigate(appPaths.login, { replace: true }));

    return () => setLoginRedirect(null);
  }, [navigate]);

  useEffect(() => {
    if (window.location.pathname === "/") navigate(appPaths.login);
    else if (window.location.pathname?.split("/")?.[1] === "public")
      navigate(window.location.pathname + window.location.search);
  }, []);

  const updateOnlineStatus = () => {
    // if (navigator.onLine) {
    //   showSnackbar({ type: "success", message: "You are back online." });
    // } else {
    //   showSnackbar({ type: "warning", message: "You are offline." });
    // }
  };

  useEffect(() => {
    window.addEventListener("load", updateOnlineStatus);
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("load", updateOnlineStatus);
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [navigator.onLine]);

  return (
    <GlobalModalProvider>
      <PreviousPathProvider>
        <Outlet />
      </PreviousPathProvider>
    </GlobalModalProvider>
  );
};

export default RootLayout;
